module.exports = __webpack_public_path__ + "static/img/4380_phase_function_Paper_Points.a5bdd5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4380_phase_function_Paper_Points.png
// module id = m0ui
// module chunks = 0